import LinkTypeEnum from 'redpoints-model-js/enumeration/LinkTypeEnum';

import {
  LINKS_MANAGEMENT_CLEAR,
  LINKS_MANAGEMENT_LINK_AVAILABILITY_URL_FORMAT_ERROR,
  LINKS_MANAGEMENT_LINKS_SET_PROCESSING_CONTENT_LINKS,
  LINKS_MANAGEMENT_LINKS_SET_PROCESSING_DETECTION_LINKS,
  LINKS_MANAGEMENT_SET_LINK_AVAILABILITY_ERROR,
  LINKS_MANAGEMENT_SET_LINK_AVAILABILITY_FAILURE,
  LINKS_MANAGEMENT_SET_LINK_AVAILABILITY_REQUEST,
  LINKS_MANAGEMENT_SET_LINK_AVAILABILITY_SUCCESS,
  LINKS_MANAGEMENT_SET_LINK_BY_URL_ERROR,
  LINKS_MANAGEMENT_SET_LINK_BY_URL_FAILURE,
  LINKS_MANAGEMENT_SET_LINK_BY_URL_REQUEST,
  LINKS_MANAGEMENT_SET_LINK_BY_URL_SUCCESS,
  LINKS_MANAGEMENT_SET_LINK_DEINDEXATION_STATUS_BY_URL_ERROR,
  LINKS_MANAGEMENT_SET_LINK_DEINDEXATION_STATUS_BY_URL_FAILURE,
  LINKS_MANAGEMENT_SET_LINK_DEINDEXATION_STATUS_BY_URL_REQUEST,
  LINKS_MANAGEMENT_SET_LINK_DEINDEXATION_STATUS_BY_URL_SUCCESS,
  LINKS_MANAGEMENT_URL_FORMAT_ERROR,
} from '../../../../actions/actionTypes';
import LinksManagementSetLinkStatusEnum from '../../../../enumerations/LinksManagementSetLinkStatusEnum';

const defaultState = {
  contentLinks: [],
  detectionLinks: [],
  newStatus: null,
  selectedReason: null,
};

const updateLinkStatus = (state, payload, nextStatus) => {
  let propertyName = null;
  if (payload.linkType === LinkTypeEnum.DETECTION) {
    propertyName = 'detectionLinks';
  } else if (payload.linkType === LinkTypeEnum.CONTENT) {
    propertyName = 'contentLinks';
  } else {
    return state;
  }

  return {
    ...state,
    [propertyName]: [...state[propertyName]].map(link => {
      if (link.url === payload.url) {
        link.status = nextStatus;
      }
      return link;
    }),
  };
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case LINKS_MANAGEMENT_LINKS_SET_PROCESSING_CONTENT_LINKS:
      return {
        ...state,
        contentLinks: action.payload.contentLinks,
        newStatus: action.payload.newStatus,
        selectedReason: action.payload.selectedReason,
      };

    case LINKS_MANAGEMENT_LINKS_SET_PROCESSING_DETECTION_LINKS:
      return {
        ...state,
        detectionLinks: action.payload.detectionLinks,
        newStatus: action.payload.newStatus,
        selectedReason: action.payload.selectedReason,
      };

    case LINKS_MANAGEMENT_SET_LINK_AVAILABILITY_REQUEST:
      return updateLinkStatus(
        state,
        action.payload.linkSetUnavailableObject,
        LinksManagementSetLinkStatusEnum.PROCESSING
      );

    case LINKS_MANAGEMENT_SET_LINK_DEINDEXATION_STATUS_BY_URL_REQUEST:
    case LINKS_MANAGEMENT_SET_LINK_BY_URL_REQUEST:
      return updateLinkStatus(
        state,
        action.payload.linkSetStatusObject,
        LinksManagementSetLinkStatusEnum.PROCESSING
      );

    case LINKS_MANAGEMENT_SET_LINK_AVAILABILITY_SUCCESS:
      return updateLinkStatus(
        state,
        action.payload.linkSetUnavailableObject,
        LinksManagementSetLinkStatusEnum.SUCCESS
      );

    case LINKS_MANAGEMENT_SET_LINK_BY_URL_SUCCESS:
    case LINKS_MANAGEMENT_SET_LINK_DEINDEXATION_STATUS_BY_URL_SUCCESS:
      return updateLinkStatus(
        state,
        action.payload.linkSetStatusObject,
        LinksManagementSetLinkStatusEnum.SUCCESS
      );

    case LINKS_MANAGEMENT_LINK_AVAILABILITY_URL_FORMAT_ERROR:
    case LINKS_MANAGEMENT_SET_LINK_AVAILABILITY_ERROR:
    case LINKS_MANAGEMENT_SET_LINK_AVAILABILITY_FAILURE:
      return updateLinkStatus(
        state,
        action.payload.linkSetUnavailableObject,
        LinksManagementSetLinkStatusEnum.ERROR
      );

    case LINKS_MANAGEMENT_SET_LINK_BY_URL_ERROR:
    case LINKS_MANAGEMENT_SET_LINK_BY_URL_FAILURE:
    case LINKS_MANAGEMENT_SET_LINK_DEINDEXATION_STATUS_BY_URL_ERROR:
    case LINKS_MANAGEMENT_SET_LINK_DEINDEXATION_STATUS_BY_URL_FAILURE:
    case LINKS_MANAGEMENT_URL_FORMAT_ERROR:
      return updateLinkStatus(
        state,
        action.payload.linkSetStatusObject,
        LinksManagementSetLinkStatusEnum.ERROR
      );

    case LINKS_MANAGEMENT_CLEAR:
      return defaultState;

    default:
      return state;
  }
}
